var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.05,
    height: 56.063,
    viewBox: "0 0 37.05 46.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47489",
    "data-name": "Group 47489",
    transform: "translate(-51.5 -288.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file",
    "data-name": "Icon feather-file",
    transform: "translate(46 285.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16650",
    "data-name": "Path 16650",
    d: "M26.278,3H10.506A4.506,4.506,0,0,0,6,7.506v36.05a4.506,4.506,0,0,0,4.506,4.506H37.544a4.506,4.506,0,0,0,4.506-4.506V18.772Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16651",
    "data-name": "Path 16651",
    d: "M19.5,3V18.772H35.272",
    transform: "translate(6.778)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(62 316.879)",
    fontSize: 8,
    fontFamily: "OpenSans-Extrabold, Open Sans",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IMG")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1b1617753ee601092d2881327f1fc4f2.svg";
export { ForwardRef as ReactComponent };